module.exports = __webpack_public_path__ + "static/media/lk.43cbeee0.svg";